export default {
  disponibileBio: 'Disponibile Bio',
  certificatoBio: 'Certificato Bio',
  'Certificato Bio': 'Certificato Bio',
  'Disponibile Bio': 'Disponibile Bio',
  vino: 'Vino',
  birra: 'Cerveza',
  panificati: 'Productos de panadería',
  agricoltura: 'Agricultura',
  nutraceutica: 'Nutracéutica',
  altriProdotti: 'Otros productos de la misma familia',
  structuredTitle: 'Aumenta la eficacia de {title} con:',
  prefix: {
    vino: 'Vinos',
  },
  adattoPer: 'Adecuado para',
  stili: 'Estilos',
  disponibilitaProdotto: 'Disponible en formatos: ',
}
